// src/services/analyticsService.js
import { analytics } from '../firebase';
import { logEvent, setUserProperties } from 'firebase/analytics';

class AnalyticsService {
  constructor() {
    this.isEnabled = !!analytics;
  }

  // Track page views
  trackPageView(pageName, pageTitle = '') {
    if (!this.isEnabled) return;
    
    try {
      logEvent(analytics, 'page_view', {
        page_title: pageTitle || pageName,
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    } catch (error) {
      console.warn('Analytics tracking failed:', error);
    }
  }

  // Track blog post views
  trackBlogView(blogId, blogTitle, category = '') {
    if (!this.isEnabled) return;
    
    try {
      logEvent(analytics, 'blog_view', {
        blog_id: blogId,
        blog_title: blogTitle,
        category: category,
        timestamp: Date.now()
      });
    } catch (error) {
      console.warn('Blog analytics tracking failed:', error);
    }
  }

  // Track search events
  trackSearch(searchTerm, resultsCount = 0) {
    if (!this.isEnabled) return;
    
    try {
      logEvent(analytics, 'search', {
        search_term: searchTerm,
        results_count: resultsCount
      });
    } catch (error) {
      console.warn('Search analytics tracking failed:', error);
    }
  }

  // Track social sharing
  trackSocialShare(platform, contentType, contentId) {
    if (!this.isEnabled) return;
    
    try {
      logEvent(analytics, 'share', {
        method: platform,
        content_type: contentType,
        content_id: contentId
      });
    } catch (error) {
      console.warn('Social share analytics tracking failed:', error);
    }
  }

  // Track user engagement time
  trackEngagementTime(pageName, timeSpent) {
    if (!this.isEnabled) return;
    
    try {
      logEvent(analytics, 'user_engagement', {
        page_name: pageName,
        engagement_time_msec: timeSpent
      });
    } catch (error) {
      console.warn('Engagement analytics tracking failed:', error);
    }
  }

  // Set user properties
  setUserProperty(propertyName, value) {
    if (!this.isEnabled) return;
    
    try {
      setUserProperties(analytics, {
        [propertyName]: value
      });
    } catch (error) {
      console.warn('User property setting failed:', error);
    }
  }

  // Track custom events
  trackCustomEvent(eventName, parameters = {}) {
    if (!this.isEnabled) return;
    
    try {
      logEvent(analytics, eventName, parameters);
    } catch (error) {
      console.warn('Custom event tracking failed:', error);
    }
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;